






























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { DashboardViewModel } from '@/models/dashboard/DashboardViewModel';

export default Vue.extend({
  name: 'aarselever-view',
  props: {
    viewModel: {
      type: Object as () => DashboardViewModel
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  async mounted() {
    await this.loadAnnualManhoursAverage(this.viewModel);
  },
  methods: {
    ...mapActions('dashboardStore', ['loadAnnualManhoursAverage']),

  },
  computed: {
    ...mapGetters('dashboardStore', ['groupEntries', 'groupKeyLabel', 'groupValueLabel', 'infoboxLabel', 'infoboxValue']),
    
  },
  watch: {
    'viewModel': {
      deep: true,
      async handler(newValue) {
        await this.loadAnnualManhoursAverage(this.viewModel);
        console.log(['loadAnnualManhoursAverage', newValue]);
      }
    }
  }

})
